import React from 'react'
import { List, Segment } from 'semantic-ui-react'
import { FormattedMessage, injectIntl } from 'react-intl'


const Footer = ({ intl }) => {
    const currentYear = new Date().getFullYear()

    return (
        <Segment role="contentinfo" padded id="footer">
            <div className="footerTop">

                <div>
                    <List className="footerList">
                        <div role="listitem" className="item footerKontakt">
                            <p className="item">
                                <FormattedMessage
                                    id="Footer-Kontakt"
                                    defaultMessage="Kontakt"
                                />
                            </p>
                        </div>
                        <div role="listitem" className="item">
                            <i className="ri-phone-line"></i>
                            <a className="item" href="tel:034 445 60 40">
                                <FormattedMessage
                                    id='Footer-Telefon'
                                    defaultMessage="034 445 60 40"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item">
                            <i className="ri-mail-line"></i>
                            <a className="item" href="mailto:info@gate-swiss.ch">
                                <FormattedMessage
                                    id='Footer-Email'
                                    defaultMessage="info@gate-swiss.ch"
                                />
                            </a>
                        </div>
                    </List>
                </div>

                <div className='logoWhiteDiv'>
                    <img src='../logo-white.svg' alt='Logo White' className='logoWhite' />
                </div>

                <div>
                    <List className="footerList">
                        <div role="listitem" className="item footerAdresse">
                            <p className="item">
                                <FormattedMessage
                                    id="Footer-Adresse"
                                    defaultMessage="Adresse"
                                />
                            </p>
                        </div>
                        <div role="listitem" className="item">
                            <p className="item">
                                <FormattedMessage
                                    id="Footer-Name"
                                    defaultMessage="Gate-Swiss Maklerservice GmbH"
                                />
                            </p>
                        </div>
                        <div role="listitem" className="item">
                            <p className="item">
                                <FormattedMessage
                                    id="Footer-Adress"
                                    defaultMessage="Ersigenstrasse 9"
                                />
                            </p>
                        </div>
                        <div role="listitem" className="item">
                            <p className="item">
                                <FormattedMessage
                                    id='Footer-Plz-Ort'
                                    defaultMessage="3422 Kirchberg"
                                />
                            </p>
                        </div>
                    </List>
                </div>
            </div>
            <hr />
            <div className='footerBottom'>
                <div>
                    <List className="footerList">
                        <div role="listitem" className="item">
                            <a className="item" href="./impressum">
                                <FormattedMessage
                                    id='Footer-Imprint'
                                    defaultMessage="Impressum"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item">
                            <a className="item" href="./datenschutz">
                                <FormattedMessage
                                    id='Footer-Privacy'
                                    defaultMessage="Datenschutzerklärung"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item">
                            <i className="ri-copyright-line"></i>
                            {currentYear}&nbsp;
                            <FormattedMessage
                                id='Footer-Copyright'
                                defaultMessage="Gate-Swiss Maklerservice GmbH"
                            />
                        </div>
                    </List>
                </div>
            </div>
        </Segment>
    );
};

export default injectIntl(Footer);